import * as React from "react";
import { useState } from "react";
import { useNavigate, useParams } from "react-router";
import Grid from "@mui/material/Grid2";
import ProductCategory from "./ProductCategory";
import ProductLists from "./ProductLists";

function ProductGrid() {
  const [selectedCat, setSelectedCat] = useState([]);
  const {category_id} = useParams();

  return (
    <Grid container spacing={2} className="product-main-container">
      <Grid
        size={{ lg: 3, md: 3 }}
        className="product-cate-grid"
        sx={{ display: { lg: "block", md: "block", sm: "none", xs: "none" } }}
      >
        <ProductCategory setSelectedCat={setSelectedCat} flag={0} category_id={category_id} />
      </Grid>

      <Grid
        size={{ lg: 9, xs: 12, sm: 12, md: 9 }}
        className="product-cate-grid"
      >
        <ProductLists
          selectedCat={selectedCat}
          setSelectedCat={setSelectedCat}
          category_id={category_id}
        />
      </Grid>
    </Grid>
  );
}
export default ProductGrid;
